export default "__VITE_ASSET__BAo308rS__"